import { render, staticRenderFns } from "./资产招商详情.vue?vue&type=template&id=6a1b5b4e&scoped=true"
import script from "./资产招商详情.vue?vue&type=script&lang=js"
export * from "./资产招商详情.vue?vue&type=script&lang=js"
import style0 from "./资产招商详情.vue?vue&type=style&index=0&id=6a1b5b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b5b4e",
  null
  
)

export default component.exports